import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import { GetServerSideProps } from 'next';
import { Lang } from '@models/lang';
import Hero from '@components/Hero';
import CardLang from '@components/CardLang';
import LayoutPage from '@components/LayoutPage';
import { getLangs } from '@fetchers/langs';

interface Props {
  langs: Lang[];
}

export default function Challenges({ langs }: Props) {
  const { t } = useTranslation('common');

  return (
    <>
      <Head>
        <title>{t('langs.metaTitle')}</title>
        <meta name="description" content={t('langs.metaDescription')} />
      </Head>
      <LayoutPage>
        <Hero
          title={t('langs.title')}
          text={t('langs.text')}
          icon="/icons/trophy-dynamic-premium.png"
        />
        <div className="mt-6 grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-3 xl:gap-x-8">
          {langs.map((item, index) => (
            <CardLang lang={item} key={index} />
          ))}
        </div>
      </LayoutPage>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async ({ locale, res }) => {
  const langs = await getLangs();
  const ssrConfig = await serverSideTranslations(locale, ['common']);
  res.setHeader('Cache-Control', 'public, s-maxage=10, stale-while-revalidate=59');
  return {
    props: {
      langs,
      ...ssrConfig,
    },
  };
};
